module.exports = __webpack_public_path__ + "static/media/nivin.1f99f34e.jpeg";